import { Row, Col, Image } from "antd";

export const TrinityEndowment3Billion = () => {
  const imageStyle = {
    width: "100%",
    height: "auto",
  };

  const captionStyle = {
    textAlign: "center",
    marginTop: "8px",
  };

  return (
    <div style={{ padding: "10px" }}>
      <div style={{ textAlign: "center" }}>
        <h1 id="trinity-endowment-3-billion">
          Trinity College Kandy Receives Historic Rs. 3 Billion Donation from
          Eng. Nahil Wijesuriya
        </h1>
      </div>
      <Row>
        <Col xs={24} sm={24} md={24}>
          <p>
            <strong>17 June 2026</strong> marked a historic moment in the
            history of <strong>Trinity College Kandy</strong>, as distinguished
            old boy, engineer, entrepreneur, and philanthropist{" "}
            <strong>Eng. Nahil Wijesuriya</strong> donated{" "}
            <strong>LKR 3 billion</strong> to his alma mater, the largest single
            donation ever made by an Old Boy to the College.
          </p>

          <p>
            The gift will establish the{" "}
            <strong>Nahil Wijesuriya Endowment Fund (NWEF)</strong>, ensuring
            the donation is managed prudently and invested sustainably to
            strengthen Trinity's long-term future. Income generated by the fund
            will support educational excellence, holistic student development,
            and the College's continued growth as one of Sri Lanka's leading
            educational institutions.
          </p>

          <p>
            In an official letter dated <strong>27 June 2026</strong>, Trinity
            College Principal <strong>Rev. Fr. Araliya Jayasundara OSB</strong>{" "}
            described the contribution as:
          </p>

          <blockquote>
            <p>
              "The largest single donation ever made by an old boy to his alma
              mater."
            </p>
          </blockquote>

          <p>
            He added that the donation represents more than financial generosity,
            it is a lasting investment in future generations of Trinitians and a
            reaffirmation of the values instilled by the College.
          </p>

          <p>
            The Principal also noted that the endowment has been established
            with a carefully designed governance framework to ensure the funds
            are stewarded with integrity and continue benefiting the College in
            perpetuity.
          </p>

          <p>
            Nahil Wijesuriya has long been recognised for his commitment to
            education and philanthropy in Sri Lanka, having previously supported
            institutions including <strong>S. Thomas' College, Mount Lavinia</strong>,{" "}
            <strong>Ananda College</strong>, and{" "}
            <strong>Bishop's College Colombo</strong>. His latest contribution
            further cements his legacy as one of the country's most significant
            educational philanthropists.
          </p>

          <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
            <Col xs={24} md={12}>
              <Image
                style={imageStyle}
                src={
                  "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/75-trinity-endowment-3-billion/letter-from-rev-araliya.jpg"
                }
              />
              <div style={captionStyle}>
                <p>
                  <small>Letter from Rev. Fr. Araliya Jayasundara OSB</small>
                </p>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <Image
                style={imageStyle}
                src={
                  "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/75-trinity-endowment-3-billion/trinity-collge-post-nahil-donation.jpg"
                }
              />
              <div style={captionStyle}>
                <p>
                  <small>Trinity College announcement</small>
                </p>
              </div>
            </Col>
          </Row>

          <h2>Read More</h2>
          <ul>
            <li>
              <strong>Newswire: </strong>
              <a
                href="https://www.newswire.lk/2026/06/17/trinity-announces-landmark-rs-3-billion-gift-from-distinguished-old-boy-nahil-wijesuriya/"
                target="_blank"
                rel="noreferrer"
              >
                Trinity announces landmark Rs. 3 billion gift from
                distinguished old boy Nahil Wijesuriya
              </a>
            </li>
            <li>
              <strong>Official Trinity College Announcement: </strong>
              <a
                href="https://trinitycollege.lk/2026/06/17/trinity-college-kandy-receives-lkr-3-billion-donation-from-eng-nahil-wijesuriya/"
                target="_blank"
                rel="noreferrer"
              >
                Trinity College Kandy receives LKR 3 billion donation from Eng.
                Nahil Wijesuriya
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </div>
  );
};